export default "__VITE_ASSET__iUhmriw5__"